import { useUpdateSearchFilterTitleMutation } from '@entities/search'

import { GETSearchType } from '@types'

interface UpdateSearchFilterTitleHookProps {
  editSearchFilterTitle: string
  onUpdateTitle: (searchFilter: GETSearchType) => void
}

export const useUpdateSearchFilterTitleManager = (props: UpdateSearchFilterTitleHookProps) => {
  const { editSearchFilterTitle, onUpdateTitle } = props

  const [updateSearchFilterTitle, { isLoading: isUpdatingSearchFilterTitle }] =
    useUpdateSearchFilterTitleMutation()

  const handleUpdateTitle = (selectedSearchFilterId: number | undefined) => {
    if (selectedSearchFilterId) {
      updateSearchFilterTitle({ title: editSearchFilterTitle, id: selectedSearchFilterId })
        .unwrap()
        .then(onUpdateTitle)
    }
  }

  return { handleUpdateTitle, isUpdatingSearchFilterTitle }
}
